import {
  GET_MY_ADDRESSES,
  MY_ADDRESSES_ERROR,
  ADD_NEW_ADDRESS,
  REMOVE_ADDRESS,
  EDIT_ADDRESS,
} from "../actions/types";

const initialState = {
  addresses: [],
  loading: true,
  error: {},
};

export default (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_MY_ADDRESSES:
      return {
        ...state,
        addresses: payload,
        loading: false,
      };
    case MY_ADDRESSES_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    case ADD_NEW_ADDRESS:
      state.addresses.push(payload);
      return {
        ...state,
        loading: false,
      };
    case EDIT_ADDRESS:
      let newAddressesEdit = state.addresses.filter(
        ({ addressId }) => addressId !== payload.addressId
      );
      newAddressesEdit.push(payload);
      newAddressesEdit.sort((a, b) => {
        return b.principal - a.principal;
      });
      return {
        ...state,
        addresses: newAddressesEdit,
        loading: false,
      };
    case REMOVE_ADDRESS:
      let newAddressesRemove = state.addresses.filter(
        ({ addressId }) => addressId !== payload
      );
      return {
        ...state,
        addresses: newAddressesRemove,
        loading: false,
      };
    default:
      return state;
  }
};
